module.exports = __webpack_public_path__ + "img/dummy-logo.23d44499.png";